/* eslint-disable react/no-array-index-key */
/* eslint-disable no-alert */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */

import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import {
  PRIORITIES_LIST,
  SERVICE_TYPES_PRIORITY,
  StatusContext,
} from "../constants";
import { useGetTicketDetails, useUpdateTicket } from "services/tickets";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  disableTicketEditing,
  useGetParentTicketList,
  isCallCenterAgent,
} from "../utils";
import { FaChrome } from "react-icons/fa";
import { BiUser } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { Copy } from "lucide-react";
import sweetAlert from "components/sweet-alert";
import { useUser } from "hooks/use-user";
import { TicketDetailsHeader } from "components/tickets/ticket-details-header";
const emptyTicket = {
  createdBy: "",
  priority: "Normal",
  reportedBy: "",
  leadNotes: "",
  requesterEmail: "",
  region: "",
  requesterContactNo: "",
  companyName: "",
  remarks: "",
};
export default function MarketingTicketDetails() {
  const [ticketDetails, setTicketDetails] = useState("");
  const { status } = useContext(StatusContext);
  const params = useParams();
  const navigate = useNavigate();
  const user = useUser();
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const form = useForm({
    defaultValues: { ...emptyTicket },
  });

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    requesterEmail: { required: "Please Enter Value" },
    requesterContact: { required: "Please Enter Value" },
    priority: { required: "Please Select Value" },
    region: { required: "Please Select Value" },
    companyName: { required: "Please Enter Value" },
    leadNotes: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Value" },
  };

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useUpdateTicket();

  useEffect(() => {
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);
  useEffect(() => {
    if (ticketDetailsRes) {
      const _details = {
        ...ticketDetailsRes.data,

        isCustomerComplaint: ticketDetailsRes.data.isCustomerComplaint
          ? "Yes"
          : "No",
      };
      const _ticket = { ...emptyTicket, region: _details.state, ..._details };
      form.reset({ ..._ticket });
      setTicketDetails({ ..._ticket });
      resetDetailsApi();
    }

    if (createTicketRes) {
      resetCreateTicket();
      navigate(PATHS.allServiceAndNonServiceCalls);
      form.reset();
    }
    if (createTicketError) {
      resetCreateTicket();
    }
  }, [createTicketRes, createTicketError, ticketDetailsRes]);

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      remarks: _data.updatedRemarks || "",
      additionalRemarks: _data.additionalRemarks || "",
      assignmentGroup: _data.assignmentGroup || "",
    };
    createTicket(payload);
  };

  const creationChannel = useMemo(() => {
    return form.watch("creationChannel");
  }, [form.watch("creationChannel")]);

  function StatusIcon() {
    if (creationChannel === "Web") {
      return (
        <FaChrome className="text-secondary cursor-pointer" fontSize="20px" />
      );
    } else if (creationChannel === "Customer Portal") {
      return (
        <BiUser className="text-secondary cursor-pointer" fontSize="20px" />
      );
    } else if (creationChannel === "Auto Email") {
      return (
        <MdEmail className="text-secondary cursor-pointer" fontSize="20px" />
      );
    }
  }
  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTicketEditing(status);
  }, [form.watch("status")]);

  return (
    <>
      {creatingTicket || gettingTicket ? <Loader /> : <></>}

      <div className="form-container">
        <TicketDetailsHeader
          canCopy
          isFormDisabled={isFormDisabled}
          isDirty={form.formState.isDirty}
          ticket={ticketDetails}
          onSave={form.handleSubmit(onSave)}
          onReset={onReset}
        />
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Marketing</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              // onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="alertDateTime"
                    label="Alert Date Time"
                    disabled
                    hideIcons
                  />
                </div>
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="TG Reference No"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createdBy"
                    label="Opened By"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="reportedBy"
                    label="Requested By"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createDateTime"
                    label="Created At"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="requesterEmail"
                    label="Requester Email ID"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="priority"
                    label="Priority"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="requesterContactNo"
                    label="Requester Contact No"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="leadNotes"
                    label="Lead Notes"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="companyName"
                    label="Company Name"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="region"
                    label="Region"
                    disabled
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                disabled
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Remarks"
                            // isRequired={true}
                            style={{ justifyContent: "start" }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  (isFormDisabled &&
                                    ticketDetails.status !== "Cancelled")
                                }
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="additionalRemarks"
                    // rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Additional Remarks"
                            // isRequired={true}
                            style={{
                              justifyContent: "start",
                              textAlign: "left",
                              width: "100%",
                              textWrap: "nowrap",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                disabled={
                                  !isCCA ||
                                  isCSMAgent ||
                                  isFormDisabled ||
                                  form.watch("In Progress") ||
                                  form.watch("Resolved") ||
                                  form.watch("Awaiting Customer Approval") ||
                                  form.watch("Awaiting Re-Opening")
                                }
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.additionalRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.additionalRemarks ? (
                              <p className="text-destructive text-xs">
                                {
                                  form.formState.errors.additionalRemarks
                                    .message
                                }
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <Tabs
                  defaultValue="logs"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="logs">Logs</TabsTrigger>

                    <TabsTrigger value="information">
                      Additional Information
                    </TabsTrigger>
                    <TabsTrigger value="requestDetails">
                      Request Details
                    </TabsTrigger>
                    <TabsTrigger value="accessTiming">
                      Access Timings
                    </TabsTrigger>
                    <TabsTrigger value="denomination">Denomination</TabsTrigger>
                    <TabsTrigger value="resolutionInformation">
                      Resolution Information
                    </TabsTrigger>
                    <TabsTrigger value="system">system</TabsTrigger>
                  </TabsList>

                  <TabsContent value="logs">
                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className="px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={index}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>
                  <TabsContent value="information">Coming Soon</TabsContent>
                  <TabsContent value="requestDetails">Coming Soon</TabsContent>
                  <TabsContent value="accessTiming">Coming Soon</TabsContent>
                  <TabsContent value="denomination">Coming Soon</TabsContent>
                  <TabsContent value="resolutionInformation">
                    Coming Soon
                  </TabsContent>
                  <TabsContent value="system">Coming Soon</TabsContent>
                </Tabs>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
